
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"currentColor","cx":"8","cy":"8","r":"8"}}),_c('path',{attrs:{"d":"M6.102 7.785A.877.877 0 004.69 8.823l1.773 2.414a.877.877 0 001.395.023l4.125-5.247a.877.877 0 00-1.378-1.083L7.193 9.27l-1.09-1.485z","fill":"#FFF"}})])])
          )
        }
      }
    